import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import projectReducer from '../features/project/projectSlice';
import nftReducer from '../features/nft/nftSlice';
import systemReducer from '../features/system/systemSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    project: projectReducer,
    nft: nftReducer,
    system: systemReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
